/**
 * Lightweight SEO/conversion event helpers.
 * Reuses Meta Pixel (fbq) when available; no-ops safely otherwise.
 * No personal student data is sent.
 */

function deviceType() {
    if (typeof window === 'undefined') {
        return 'unknown';
    }
    return window.matchMedia('(max-width: 959px)').matches ? 'mobile' : 'desktop';
}

function pagePath() {
    if (typeof window === 'undefined') {
        return '';
    }
    return window.location.pathname;
}

export function trackSeoEvent(eventName, params = {}) {
    if (typeof window === 'undefined') {
        return;
    }

    const payload = {
        page_path: pagePath(),
        device_type: deviceType(),
        ...params,
    };

    try {
        if (typeof window.fbq === 'function') {
            window.fbq('trackCustom', eventName, payload);
        }
    } catch (error) {
        // Ignore analytics failures
    }

    try {
        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({ event: eventName, ...payload });
        }
    } catch (error) {
        // Ignore analytics failures
    }
}

export function trackSeoPageView(eventName = 'seo_grade11_curriculum_view') {
    trackSeoEvent(eventName);
}

export function trackSeoCta(eventName, placement, destination) {
    trackSeoEvent(eventName, { placement, destination });
}
